import { createRouter, createWebHistory } from "vue-router";
import { useCommon } from "../store/modules/resCommon";

const routes = [
  {
    //메인
    path: "/",
    name: "",
    component: () => import("@/layout/homeLayout.vue"),
    children: [
      {
        path: "",
        name: "Main",
        component: () => import("@/views/main/Main.vue"),
      },
      {
        path: "/logout",
        name: "Logout",
        component: () => import("@/views/logout/Logout.vue"),
      },
      {
        path: "user",
        name: "User",
        children: [
          {
            //로그인
            path: "login",
            name: "Login",
            component: () => import("@/views/user/Login.vue"),
          },
          {
            //2차인증
            path: "secondAuth",
            name: "SecondAuth",
            component: () => import("@/views/user/SecondAuth.vue"),
          },
          {
            //회원유형
            path: "joinType",
            name: "JoinType",
            component: () => import("@/views/user/JoinType.vue"),
          },
          {
            //약관동의
            path: "joinAgree/:token?",
            name: "JoinAgree",
            component: () => import("@/views/user/JoinAgree.vue"),
          },
          {
            //약관동의
            path: "memberUpdate",
            name: "MemberUpdate",
            component: () => import("@/views/user/MemberUpdate.vue"),
          },
          {
            //회원가입
            path: "join/:token",
            name: "Join",
            component: () => import("@/views/user/Join.vue"),
          },
          {
            //회원가입
            path: "emailPasswordChange/:token",
            name: "EmailPasswordChange",
            component: () => import("@/views/user/EmailPasswordChange.vue"),
          },
          {
            //이메일인증
            path: "emailAuth",
            name: "EmailAuth",
            component: () => import("@/views/user/EmailAuth.vue"),
          },
          {
            //이메일인증실패
            path: "emailAuthFail",
            name: "EmailAuthFail",
            component: () => import("@/views/user/EmailAuthFail.vue"),
          },
          {
            //아이디찾기
            path: "findLoginId",
            name: "FindLoginId",
            component: () => import("@/views/user/FindLoginId.vue"),
          },
          {
            //비밀번호 찾기
            path: "findPassword",
            name: "FindPassword",
            component: () => import("@/views/user/FindPassword.vue"),
          },
          {
            //비밀번호 변경
            path: "passwordChange",
            name: "PasswordChange",
            component: () => import("@/views/user/PasswordChange.vue"),
          },
          {
            //비밀번호 5회 오륲
            path: "asswordIncorrect",
            name: "PasswordIncorrect",
            component: () => import("@/views/user/PasswordIncorrect.vue"),
          },
          {
            //계정제한
            path: "restrictedUser",
            name: "RestrictedUser",
            component: () => import("@/views/user/RestrictedUser.vue"),
          },
        ],
      },
      {
        path: "channel",
        name: "Channel",
        meta: {
          tabMenu: "channel",
        },
        children: [
          //카카오 알림톡 설정
          {
            path: "kakao",
            name: "KakaoAlimSetting",
            component: () => import("@/views/channel/Kakao.vue"),
          },
          {
            //발신 번호 관리
            path: "sendNumber",
            name: "SendNumber",
            meta: {
              tabIndex: 6,
            },
            component: () => import("@/views/channel/SendNumber.vue"),
          },
        ],
      },
      //발송 현황
      {
        path: "shipping",
        name: "Shipping",
        meta: {
          tabMenu: "shipping",
        },
        children: [
          {
            //발송 현황
            path: "shipment",
            name: "Shipment",
            meta: {
              tabIndex: 6,
            },
            component: () => import("@/views/shipping/Shipment.vue"),
          },
          {
            //예약 현황
            path: "reservation",
            name: "Reservation",
            meta: {
              tabIndex: 6,
            },
            component: () => import("@/views/shipping/Reservation.vue"),
          },
          {
            //발송 승인
            path: "sendApproval",
            name: "SendApproval",
            meta: {
              tabIndex: 6,
            },
            component: () => import("@/views/shipping/SendApproval.vue"),
          },
        ],
      },
      {
        path: "service",
        name: "Service",
        meta: {
          tabMenu: "service",
        },
        children: [
          {
            path: "ums",
            name: "UmsService",
            component: () => import("@/views/service/Ums.vue"),
          },
          //회사 소개
          {
            path: "company",
            name: "CompanyIntroduce",
            component: () => import("@/views/service/Company.vue"),
          },
          //서비스 소개
          {
            path: "service",
            name: "ServiceIntroduce",
            component: () => import("@/views/service/Service.vue"),
          },
          //요금 안내
          {
            path: "charge",
            name: "ChargeIntroduce",
            component: () => import("@/views/service/Charge.vue"),
          },
          //서비스 신청 - 약관 동의 및 서비스 선택
          {
            path: "register",
            name: "ServiceRegister",
            component: () => import("@/views/service/Register.vue"),
          },
          //서비스 신청 - 결제 수단 등록
          {
            path: "billing",
            name: "ServiceBilling",
            component: () => import("@/views/service/Billing.vue"),
          },
          //서비스 신청 - 신청완료
          {
            path: "complete",
            name: "ServiceComplete",
            component: () => import("@/views/service/Complete.vue"),
          },
        ],
      },
      //내 정보(부모)
      {
        path: "myInfo",
        name: "",
        meta: {
          tabMenu: "myInfo",
        },
        children: [
          //내정보
          {
            path: "",
            name: "MyInformation",
            component: () => import("@/views/myPage/myInfo/MyInfo.vue"),
          },
          //과금정보
          {
            path: "billingInfo",
            name: "MyInfoBillingInfo",
            component: () => import("@/views/myPage/myInfo/BillingInfo.vue"),
          },
          //결제정보
          {
            path: "payment",
            name: "MyInfoPayment",
            component: () => import("@/views/myPage/myInfo/Payment.vue"),
          },
          //080수신거부현황
          {
            path: "unsubscribe",
            name: "MyInfoUnsubscribe",
            component: () => import("@/views/myPage/myInfo/Unsubscribe.vue"),
          },
          //통계
          {
            path: "statistics",
            name: "MyInfoStatistics",
            component: () => import("@/views/myPage/myInfo/Statistics.vue"),
          },
        ],
      },
      {
        path: "ratePlan",
        name: "RatePlan",
        meta: {
          tabMenu: "ratePlan",
        },
        children: [
          {
            path: "ums",
            name: "UmsRatePlan",
            component: () => import("@/views/ratePlan/UmsRatePlan.vue"),
          },
        ],
      },
      {
        path: "myPage",
        name: "MyPage",
        meta: {
          tabMenu: "myPage",
        },
        component: () => import("@/views/myPage/MyPage.vue"),
        children: [
          {
            //나의정보관리
            path: "info",
            name: "MyInfo",
            meta: {
              tabIndex: 1,
            },
            component: () => import("@/views/myPage/Info.vue"),
          },
          {
            //1:1문의 관리
            path: "question",
            name: "Question",
            meta: {
              tabIndex: 2,
            },
            children: [
              {
                //리스트
                path: "list",
                name: "QuestionList",
                component: () => import("@/views/myPage/question/list.vue"),
              },
              {
                //상세
                path: "view",
                name: "QuestionView",
                component: () => import("@/views/myPage/question/View.vue"),
              },
              {
                //등록
                path: "regist",
                name: "QuestionRegist",
                component: () => import("@/views/myPage/question/Regist.vue"),
              },
            ],
          },
          {
            //나의서비스그룹 관리
            path: "serviceGroup",
            name: "MyServiceGroup",
            meta: {
              tabIndex: 5,
            },
            children: [
              {
                //리스트
                path: "list",
                name: "MyServiceGroupList",
                component: () => import("@/views/myPage/serviceGroup/list.vue"),
              },
              {
                //상세
                path: "view",
                name: "MyServiceGroupView",
                meta: {
                  title: "서비스 그룹 관리",
                  tabFlag: "N",
                },
                component: () => import("@/views/myPage/serviceGroup/View.vue"),
              },
              {
                path: "appKey",
                name: "AppKey",
                meta: {
                  title: "서비스 그룹 관리",
                  tabFlag: "N",
                },
                component: () => import("@/views/myPage/serviceGroup/appkeyManager/appKey.vue"),
              },
              {
                path: "serviceDetail",
                name: "ServiceDetail",
                meta: {
                  title: "서비스 그룹 관리",
                  tabFlag: "N",
                },
                component: () => import("@/views/myPage/serviceGroup/serviceDetail/serviceDetail.vue"),
              },
            ],
          },

          {
            //통계
            path: "statistics",
            name: "MyStatistics",
            meta: {
              tabIndex: 4,
            },
            component: () => import("@/views/myPage/MyStatistics.vue"),
          },

        ],
      },
      {
        //탈퇴하기
        path: "secession",
        name: "Secession",
        component: () => import("@/views/myPage/Secession.vue"),
      },
      {
        path: "customerService",
        name: "CustomerService",
        meta: {
          tabMenu: "customerService",
        },
        children: [
          {
            //공지사항
            path: "notice",
            name: "Notice",
            children: [
              {
                path: "list",
                name: "NoticeList",
                component: () => import("@/views/customerService/notice/NoticeList.vue"),
              },
              {
                path: "view",
                name: "NoticeView",
                component: () => import("@/views/customerService/notice/NoticeView.vue"),
              },
            ],
          },
          {
            //자주 묻는 질문
            path: "FAQ",
            name: "FAQ",
            component: () => import("@/views/customerService/FAQ.vue"),
          },
        ],
      },
      {
        path: "manage",
        name: "Manage",
        children: [
          {
            path: "member",
            name: "Member",
            component: () => import("@/views/manage/member/member.vue"),
            children: [
              {
                path: "manageMember",
                name: "ManageMember",
                meta: {
                  tabIndex: 1,
                },
                component: () => import("@/views/manage/member/manageMember.vue"),
              },
              {
                path: "addMember",
                name: "AddMember",
                meta: {
                  tabIndex: 2,
                },
                component: () => import("@/views/manage/member/addMember.vue"),
              },
            ],
          },
        ],
      },
      {
        path: "billing",
        name: "Billing",
        component: () => import("@/views/serviceGroupBill/Billing.vue"),
        children: [
          // {
          //   path: "prepaidBilling",
          //   name: "PrepaidBilling",
          //   component: () => import("@/views/serviceGroupBill/PrepaidBilling.vue"),
          //   meta: {
          //     tabIndex: 1,
          //   },
          // },
          // {
          //   path: "subscriptionBilling",
          //   name: "SubscriptionBilling",
          //   component: () => import("@/views/serviceGroupBill/SubscriptionBilling.vue"),
          //   meta: {
          //     tabIndex: 2,
          //   },
          // },
          {
            path: "postpaidBilling",
            name: "PostpaidBilling",
            component: () => import("@/views/serviceGroupBill/PostpaidBilling.vue"),
            meta: {
              tabIndex: 1,
            },
          },
        ],
      },
      {
        path: "billingRecord",
        name: "BillingRecord",
        component: () => import("@/views/serviceGroupBill/BillingRecord.vue"),
      },
      {
        path: "webPush",
        name: "WebPush",
        component: () => import("@/views/webPush/test.vue"),
      },
    ],
  },
//가입안내 페이지
  {
        path: "/information",
        name: "",
        meta: {
          tabMenu: "info",
        },
        children: [
          //신규가입안내
          {
            path: "register",
            name: "InfoRegister",
            component: () => import("@/views/information/RegistrationInformation.vue"),
          },
          //전환가입안내
          {
            path: "conversion",
            name: "InfoConversion",
            component: () => import("@/views/information/ConversionInformation.vue"),
          },
        ],
      },

  {
    //PMS
    path: "/pms",
    name: "",
    component: () => import("@/layout/pmsLayout.vue"),
    children: [
      {
        //나의 정보 관리
        path: "myinfo",
        name: "PMSMyInfo",
        meta: {
          tabIndex: 1,
        },
        component: () => import("@/views/pms/myInfo/MyInfo.vue"),
      },
      {
        //탈퇴하기
        path: "secession",
        name: "PMSSecession",
        component: () => import("@/views/pms/myInfo/Secession.vue"),
      },
      {
        //발송/예약 현황
        path: "status",
        name: "PMSStatus",
        meta: {
          tabIndex: 2,
        },
        component: () => import("@/views/pms/status/StatusIndex.vue"),
      },
      {
        //통계
        path: "statistics",
        name: "PMStatistics",
        meta: {
          tabIndex: 3,
        },
        component: () => import("@/views/pms/statistics/StatisticsIndex.vue"),
      },
      {
        //과금 정보 및 설정
        path: "billing",
        name: "PMSBilling",
        meta: {
          tabIndex: 4,
        },
        component: () => import("@/views/pms/billing/BillingIndex.vue"),
      },
      {
        //카카오 알림톡 설정
        path: "kakao",
        name: "PMSKakao",
        meta: {
          tabIndex: 5,
        },
        component: () => import("@/views/pms/kakao/KakaoIndex.vue"),
      },
      {
        //발신 번호 관리
        path: "sendnumber",
        name: "PMSSendNumber",
        meta: {
          tabIndex: 6,
        },
        component: () => import("@/views/pms/sendNumber/sendNumber.vue"),
      },
    ],
  },
  {
    path: "/addiauth/otp",
    name: "AdditionalAuthOtp",
    component: () => import("@/views/addiauth/AdditionalAuthOtp.vue"),
  },
  {
    path: "/pms/sso/callback",
    name: "PmsSsoCallback",
    component: () => import("@/components/SsoCallback.vue"),
  },
  {
    path: "/pay/callback/:code?/:message?",
    name: "payCallback",
    component: () => import("@/components/payCallback.vue"),
  },
  {
    path: "/pay/call",
    name: "payCall",
    component: () => import("@/components/payCall.vue"),
  },
  {
    path: "/pay/call/billkey",
    name: "payCallBillkey",
    component: () => import("@/components/payCallBillkey.vue"),
  },
  {
    path: "/pay/close",
    name: "payClose",
    component: () => import("@/components/payClose.vue"),
  },
  {
    path: "/:pathMatch(.*)*", // 일치하지 않는 모든 경로를 처리하는 라우트
    component: () => import("@/views/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  errorCaptured(error) {
    return { path: "/notFound", error };
  },
});

//페이지 이동하기전 로직
router.beforeEach(async (to, from, next) => {
  const commonStore = useCommon();
  //로딩바 카운터 초기화
  commonStore.loadingBarClear();
  commonStore.popAlertFlag = false;
  commonStore.popConfirmFlag = false;
  
  // errorMsg 쿼리스트링 확인 및 팝업 표시
  if (to.query.errorMsg) {
    const errorMsg = to.query.errorMsg;
    // 쿼리스트링에서 errorMsg 제거하고 이동
    const newQuery = { ...to.query };
    delete newQuery.errorMsg;
    next({ ...to, query: newQuery });
    // 다음 틱에서 alert 표시 (동적 import로 Pinia 초기화 후 사용)
    setTimeout(async () => {
      const { cmmn } = await import("../common/common");
      cmmn.alert(errorMsg, 'e');
    }, 100);
    return;
  }
  
  next();
});

export default router;
